import React from "react";
import { Button } from "reactstrap";
import dataText from "../../data";
import * as S from "./StartButtonsStyle";

const StartButtons = (props) => {
  const showNextButton = props.showNextButton;
  const showStartButton = props.showStartButton;
  const onStartBtnClick = () => props.onStartBtnClick();
  const onPlayNextBtnClick = () => props.onPlayNextBtnClick();

  const bootstrapStyle = {
    color: "success",
    size: "lg",
  };

  return (
    <S.PlayButtonsContainer>
      <Button
        hidden={!showStartButton}
        {...bootstrapStyle}
        onClick={onStartBtnClick}
      >
        {dataText.start}
      </Button>
      <Button
        hidden={!showNextButton}
        {...bootstrapStyle}
        onClick={onPlayNextBtnClick}
      >
        {dataText.playNext}
      </Button>
      <Button id={"switchEarsBtn"} hidden>
        {" "}
        Vaheta kõrv{" "}
      </Button>
    </S.PlayButtonsContainer>
  );
};

export default StartButtons;
